<template>
<div class="content">
  <q-card>
    <div class="row">
      <div class="col">
        <q-radio class="button" v-model="type" val='1' :label="$t('global.DistanceBased')" />
        <q-radio class="button" v-model="type" val='2' :label="$t('global.TimeBased')" />
      </div>
        <div class="col-xs-3">
          <q-btn class="button float-right" @click="newSchedule()" color="primary" :label="$t('global.CreateSchedule')" />
        </div>
    </div>
    <div class="row">
      <div class="col">&nbsp;</div>
    </div>
    
    <div class="row">
      <div class="col-xs-12">
        <q-table
          :title="$t('global.MaintenanceStatus')"
          :data="Schedule"
          :columns="columnsSchedule"
          row-key="MaintenanceScheduleDetailID"
          :dense="true"
          selection="multiple"
          :selected.sync="selectedRows"
          :loading="loading"
          :pagination.sync="paginationControl" 
        >
        <template slot="top-selection" slot-scope="props" >
          <div class="q-table__title">{{ $t('global.MaintenanceStatus') }}</div>
          <div>
            <q-btn color="secondary" flat :label="$t('global.Renew')" @click="processSchedule(1)" />
          </div>
          <div>
            <q-btn color="secondary" flat :label="$t('global.MarkDone')" @click="processSchedule(2)" />
          </div>
        </template>
        <q-td slot="body-cell-IsHourlyWage" slot-scope="props" :props="props">
          <q-checkbox v-model="props.row.IsHourlyWage" disable  />
        </q-td>
        <q-td slot="body-cell-IsActive" slot-scope="props" :props="props">
          <q-checkbox v-model="props.row.IsActive" disable  />
        </q-td>
        <td slot="body-cell-Status" slot-scope="props" :props="props">
          <q-btn v-if="checkOverdue(props.row)" color="primary" flat round icon="check_circle"  />
          <q-btn v-if="!checkOverdue(props.row)" color="negative" flat round icon="highlight_off"  />
        </td>
        </q-table>
      </div>
    </div>
    </q-card>
</div>

</template>

<script>
import axios from 'axios'
import qs from 'qs'
import {eventBus} from '../../main'
import { date } from 'quasar'

export default {
  name: 'UserList',
  data: function () {
    return {
      type: '1',
      loading: false,
      form: {
        SessionId: null,
        action: 'GetMaintenanceScheduleDetail'
      },
      Schedule:[],
      selectedRows: [],  
      columnsSchedule: [
      {
        name: 'Status',
        required: true,
        label: this.$t('global.Status'),
        align: 'right',
        sortable: false
      },
      {
        name: 'DeviceName', required: true,label: this.$t('global.Unit'),align: 'left',
        field: 'DeviceName',sortable: true
      },
      {
        name: 'KmDiff', required: true,label: this.$t('global.KmDue'),align: 'right',
        field: 'KmDiff',sortable: true,
        format: val => round(val,2)
      },
      {
        name: 'TimeDiffDay', required: true,label: this.$t('global.DayDue'),align: 'right',
        field: 'TimeDiffDay',sortable: true
      },
      {
        name: 'MaintenanceScheduleName', required: true,label: this.$t('global.Name'),align: 'left',
        field: 'MaintenanceScheduleName',sortable: true
      },
      {
        name: 'Description', required: true,label: this.$t('global.Description'),align: 'left',
        field: 'Description',sortable: true
      },
      {
        name: 'Start',required: true,label: this.$t('global.Begin'),align: 'right',
        field: 'Start',sortable: true,
        format: val => this.dateFormat(val)
      },
      {
        name: 'StartOdo',required: true,label: this.$t('global.StartMeter'),align: 'right',
        field: 'StartOdo',sortable: true
      },
      {
        name: 'VirtualOdo',required: true,label: this.$t('global.OdoMeter'),align: 'right',
        field: 'VirtualOdo',sortable: true
      },
          
      ],
      paginationControl: { rowsPerPage: 10, page: 1 },
    }
    
  },
  methods: {
    loadData(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "GetMaintenanceScheduleDetail"
      this.form.type = this.type
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.Schedule = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },

    processSchedule(type){
      var schedlist = []
      this.selectedRows.forEach(function (value) {
        schedlist.push(value.MaintenanceScheduleDetailID)
      })
      var dialog = null
      if(type == 2){
        dialog = {
          title: this.$t('global.MarkDone'),
          message: this.$t('global.MarkSchedule', {count: this.selectedRows.length}),
          cancel: true, 
          persistent: true      
        }
      }
      if(type == 1){
        dialog = {
          title: this.$t('global.Renew'),
          message: this.$t('global.RenewSchedule', {count: this.selectedRows.length}),
          cancel: true, 
          persistent: true   
        }
      }
      this.$q.dialog(dialog)
      .onOk(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "ProcessSchedule"
        this.form.schedlist = schedlist
        this.form.type = type

        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              if(type == 1){
                this.$q.notify({ message: this.$t('global.MaintenanceRenewed', { count: response.data }), type: 'positive'})
              }
              if(type == 2){
                this.$q.notify({ message: this.$t('global.MaintenanceMarkedDone', { count: response.data }), type: 'positive'})
              }
              this.loadData()
              this.selectedRows = []
              this.loadData()
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      })
      .onCancel(() => {
        //alert('Picked cancel')
      })
    },
    newSchedule(){
      eventBus.$emit('loadDialog', "CreateMaintenanceSchedule")
    },
    dateFormat(val) {
      if (this.$i18n.locale == "de")
        return date.formatDate(val, 'DD.MM.YYYY HH:mm:ss')
      else
        return date.formatDate(val, 'MM/DD/YYYY HH:mm:ss')
    },
    decFormat(val) {
      return val.toFixed(2)
    },
    checkOverdue(Schedule){
      if(this.type == '1'){
        if(Schedule.KmDiff < 0){
          return false
        }
        else{
          return true
        }
      }
      if(this.type == '2'){
        if(Schedule.TimeDiffDay < 0){
          return false
        }
        else{
          return true
        }
      }
    }
  },
  created () {
    this.loadData()
    eventBus.$on('Bus_ScheduleUpdate', (data) => {
      this.loadData()
    })
  },
  watch: {
    type: function (newValue, oldValue) {
      this.selectedRows = [] 
      this.loadData()
    },
   },
}
function round(value, decimals) {
  if(value == null){
    return null
  }
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
</script>
<style scoped>
.content{
  padding: 10px;
}
.button{
  margin: 10px; 
}
</style>